import { configureStore } from "@reduxjs/toolkit";
import ApiReducer from "./slices/apiSlice";
import apiContentReducer from "./slices/contentSlice/apiContent";
import contentFormReducer from "./slices/contentSlice/contentForm/contentForm";
import onedriveContentReducer from "./slices/contentSlice/onedriveContent/onedriveContent";
import addNewContentStepsReducer from "./slices/addNewContentStepsSlice";
import agreementFormReducer from "./slices/agreementFormSlice";
import dashboardConfigReducer from "./slices/dashboardConfig";
import authReducer from "./slices/user";
import successReducer from "./slices/success";
import manifestPreview from "./slices/manifestPreviewSlice";
import batchContentHandler from "./slices/batchContentHandlerSlice";

export const store = configureStore({
	reducer: {
		api: ApiReducer,
		contentForm: contentFormReducer,
		apiContent: apiContentReducer,
		oneDriveContent: onedriveContentReducer,
		addNewContentSteps: addNewContentStepsReducer,
		agreementForm: agreementFormReducer,
		dashboardConfig: dashboardConfigReducer,
		auth: authReducer,
		success: successReducer,
		manifestPreview: manifestPreview,
		batchContentHandler: batchContentHandler,
	},
});
